// Resolves a question only through the command alias registered by its
// required event; pending reconciliation remains envelope-owned.
import { z } from 'zod';

import { defineCompoundMember } from '@apps/web/features/phoebe_chat_v3/registry/types';

const userQuestionAnsweredPayloadSchema = z
    .object({
        command_id: z.uuid(),
        answer: z.string().max(100_000).nullable().optional().default(null),
    })
    .strip();

export const userQuestionAnsweredDefinitions = {
    user_question_answered: defineCompoundMember('user_question_answered', {
        disposition: 'compound_member',
        schema: userQuestionAnsweredPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
        slotMember: {
            slot: 'question',
            terminal: true,
            keys(payload) {
                return [
                    {
                        kind: 'command_id',
                        value: payload.command_id,
                    },
                ];
            },
            fragment(payload) {
                return {
                    kind: 'question_resolved',
                    commandId: payload.command_id,
                    resolution: 'answered',
                    answer: payload.answer,
                };
            },
        },
    }),
} as const;

export const userQuestionAnsweredContractFixtures = {
    valid: {
        command_id: '0198a846-739e-7a2f-a152-66a77cc11111',
        answer: 'Weekdays after 2 PM',
    },
    malformed: { command_id: 'not-a-uuid' },
} as const;
